exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/shared/components/select-portal-lang/select-portal-lang.component.scss
// module id = ../../../../../src/app/shared/components/select-portal-lang/select-portal-lang.component.scss
// module chunks = main